import { limitPositionText } from './container';

$(document).on('keydown', '[data-update-pendingcart-position-text] textarea', function(event) {
  return limitPositionText(event, $(this).val());
});
